import React, { useEffect, useState } from "react";
import "../styles/purchaseModal.css";
import Modal from "../../../shared/components/Modal";
import PurchaseActions from "../../../shared/components/PurchaseActions";
import { useAudio } from '../../../contexts/AudioContext';
import { useTranslation } from 'react-i18next';
import { entityText } from '../../../i18n/entityText';

export default function PurchaseModal({ onClose, item, index, items, onChange }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const audioRef = useAudio();
  const hasDiscount =
    Boolean(item?.originalPrice) && Boolean(item?.price) && item?.originalPrice !== item?.price;
  const discountBadge = item?.discountPercent;

  useEffect(() => {
    setVisible(true);
    // audioRef.current?.play("popup");
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
    // audioRef.current?.play("popup");
  };

  const handleLeft = () => {
    const newIndex = (index - 1 + items.length) % items.length;
    // audioRef.current?.play("btnClick");
    onChange(items[newIndex], newIndex);
  };
  const handleRight = () => {
    const newIndex = (index + 1) % items.length;
    // audioRef.current?.play("btnClick");
    onChange(items[newIndex], newIndex);
  };

  return (
    <Modal open={true} onClose={handleClose}>
      <Modal.Header title={t('shop.confirm_purchase', 'Confirm purchase')} onClose={handleClose} />
      <Modal.Body>
        <div className="purchase-images">
          <img src="./arrow-left.svg" alt={t('common.previous', 'Previous')} className="purchase-arrow" onClick={handleLeft} />
          <img
            src={item.img}
            alt={item.label}
            className={item.mostPopular ? "purchase-modal-image-most-popular" : "purchase-modal-image"}
          />
          <img src="./arrow-right.svg" alt={t('common.next', 'Next')} className="purchase-arrow" onClick={handleRight} />
        </div>

        {discountBadge ? (
          <div className="purchase-modal-popular">{discountBadge}</div>
        ) : null}

        <div className="purchase-modal-quantity">{item.label}</div>

        <div className="purchases-div">
          {hasDiscount && item.originalPrice ? (
            <div className="purchase-modal-old-price">{item.originalPrice}</div>
          ) : null}
          {item.price ? (
            <div className="purchase-modal-new-price">{item.price}</div>
          ) : null}
          {hasDiscount ? <p className="purchase-modal-desc">{t('autocollect.first_discount', 'First Purchase Discount')}</p> : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PurchaseActions
          allowTON={!!item.shopItem?.allowTon}
          allowStars={!!item.shopItem?.allowStars}
          purchaseType={item.shopItem?.type === 'PACK' ? 'PACK' : 'SHOP'}
          itemId={item.shopItem?.id}
          usdPrice={item.shopItem?.usdt}
          priceTON={item.shopItem?.priceTON}
          priceStars={item.shopItem?.priceStars}
          description={item.shopItem?.description
            ? entityText(t, 'shop_item', item.shopItem.id, 'description', item.shopItem.description)
            : entityText(t, 'shop_item', item.shopItem?.id, 'name', item.shopItem?.name)}
          onClose={handleClose}
        />
      </Modal.Footer>
    </Modal>
  );
}
